import React, { useEffect, useState } from "react";
import { getRoles } from "../utilities/genesysCloudUtils";
import { formatResourceConditionNode } from "../utilities/conditionFormatUtils";
import "../App.css";
import { CatalogTableSurface } from "./CatalogTableSurface";

export function Roles({
  setPageCount,
  pageNumber,
  setPageNumber,
  setTabName,
  opts,
  setOpts,
  setIsVisible,
  selectedExportRows = {},
  exportStatus,
  onClearExportSelection,
  onExportCsv,
  onToggleExportRow,
  onToggleVisibleExportRows,
}) {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    setPageNumber(1)
    setTabName("roles-tab");
    setOpts({})
    setIsVisible({ divisions: false, object: false, applyButton: false })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getRoles().then((data) => {
      setRoles(data.entities.sort((a, b) => a.name.localeCompare(b.name)));
      setPageCount(data.pageCount);
    });
  }, [pageNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  const allVisibleSelected = roles.length > 0 && roles.every((role) => selectedExportRows[role.id]);

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: roles })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(roles, checked)}
      rowCount={roles.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="Roles"
    >
      {roles ? (
        <>
          <table className="table">
            <thead>
              <tr>
                <th aria-label="Select rows" className="select-column"></th>
                <th>Count</th>
                <th>Role Name</th>
                <th>Role Type</th>
                <th>Role Id</th>
              </tr>
            </thead>
            <tbody>
              {roles.map((role, index) => {
                return (
                  <tr key={role.id}>
                    <td className="select-column">
                      <input
                        aria-label={`Select ${role.name} for export`}
                        checked={Boolean(selectedExportRows[role.id])}
                        onChange={(event) => onToggleExportRow(role, event.target.checked)}
                        type="checkbox"
                      />
                    </td>
                    <th className="index">{index + 1}</th>
                    <td>{role.name}</td>
                    <td>
                      <div className="collapse collapse-arrow">
                        <input type="checkbox" />
                        <div className="collapse-title">{role.description}</div>
                        <div className="collapse-content">
                          <div className="overflow-x-auto">
                            <table className="table table-xs">
                              <thead>
                                <tr>
                                  <th>Domain</th>
                                  <th>Entity Name</th>
                                  <th>Action Set</th>
                                  <th>Conditions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {role.permissionPolicies
                                  .sort(
                                    (a, b) =>
                                      a.domain.localeCompare(b.domain) ||
                                      a.entityName.localeCompare(b.entityName)
                                  )
                                  .map((policy, index) => {
                                    return (
                                      <tr key={index + 1}>
                                        <td>{policy.domain}</td>
                                        <td>
                                          {policy.entityName === "*"
                                            ? "All Permissions"
                                            : policy.entityName}
                                        </td>
                                        <td>
                                          {policy.actionSet
                                            .sort()
                                            .map((action, index, arr) => {
                                              if (action === "*") {
                                                return "All Actions";
                                              }
                                              if (arr.length - 1 === index) {
                                                return action;
                                              } else {
                                                return action + ", ";
                                              }
                                            })}
                                        </td>
                                        <td>
                                          {formatResourceConditionNode(policy.resourceConditionNode)}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>{role.default ? "Default" : "Custom"}</td>
                    <td>
                      <kbd className="kbd">{role.id}</kbd>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <h1>Loading...</h1>
      )}
    </CatalogTableSurface>
  );
}
